import 'common/css/app.css'
import './index.css'
import {baseUrl} from 'common/js/global.js'


$(function() {
  $('.application-container').find('.back').click(function() {
    history.go(-1)
  })
  getAreaLabel()
  changeCode()
  summitForm()
})

function summitForm() {
  $('.btn-wrapper').find('.btn').click(function() {
    
    var coopIntent = $('#coopIntent').val()
    var coopOrgAddress = $('#coopOrgAddress').val()
    var coopOrgCityCode = $('#coopOrgCityCode').val()
    var coopOrgContactPhone = $('#coopOrgContactPhone').val()
    var coopOrgContacts = $('#coopOrgContacts').val()
    var coopOrgDistCode = $('#coopOrgDistCode').val()
    var coopOrgEmail = $('#coopOrgEmail').val()
    var coopOrgName = $('#coopOrgName').val()
    var coopOrgProvCode = $('#coopOrgProvCode').val()
    var timer = null
    if(!coopIntent || !coopOrgAddress || !coopOrgCityCode || !coopOrgContactPhone || !coopOrgContacts || !coopOrgDistCode || !coopOrgEmail || !coopOrgName || !coopOrgProvCode){
      if (timer) clearTimeout(timer)
      $('#myAlert').find('p').html('请填写完整信息')
      $('#myAlert').show()
      timer = setTimeout(function() {
        $('#myAlert').hide()
      },2000)
    }else{
      var params = {
        coopIntent: coopIntent,
        coopOrgAddress: coopOrgAddress,
        coopOrgCityCode: coopOrgCityCode,
        coopOrgContactPhone: coopOrgContactPhone,
        coopOrgContacts: coopOrgContacts,
        coopOrgDistCode: coopOrgDistCode,
        coopOrgEmail: coopOrgEmail,
        coopOrgName: coopOrgName,
        coopOrgProvCode: coopOrgProvCode
      }
      $.ajax(baseUrl+ '/api/website/coopApply', {
        method:'POST',
        contentType: 'application/json;charset=utf-8',
        data: JSON.stringify(params),
        success : function(data) {
          if(data.errorCode == 0) {
            $('#first-wrapper').hide()
            $('#second-wrapper').show()
          }else{
            $('#myAlert').find('p').html(data.errorMsg)
            $('#myAlert').show()
            if (timer) clearTimeout(timer)
            timer = setTimeout(function() {
              $('#myAlert').hide()
            },2000)
          }
        }
      })
    }
  })
}

function changeCode() {
  $('#coopOrgProvCode').change(function() {
    var selectedId=$(this).children('option:selected').val()
    getCityLabel(selectedId)
    coopOrgDistLabel()
  })
  $('#coopOrgCityCode').change(function() {
    var selectedId = $(this).children('option:selected').val()
    coopOrgDistLabel(selectedId)
  })
}
function getAreaLabel() {
  $.get(baseUrl+ '/api/areas/label',function(data){
    if(data.errorCode == 0) {
      var areaList = data.data
      var areaOption = '<option value="">请选择省份</option>'
      for(var i = 0; i < areaList.length; i++) {
        areaOption += '<option value="'+areaList[i].id+'">'+areaList[i].text+'</option>'
      }
      $('#coopOrgProvCode').html(areaOption)
    }
  })
}

function getCityLabel(id) {
  if(id) {
    $.get(baseUrl + '/api/areas/label/'+id,function(data){
      if(data.errorCode == 0) {
        var cityList = data.data
        var cityOption = '<option value="">请选择城市</option>'
        for(var i = 0; i < cityList.length; i++){
          cityOption += '<option value="'+cityList[i].id+'">'+cityList[i].text+'</option>'
        }
        $('#coopOrgCityCode').html(cityOption)
      }
    })
  }else{
    var cityOption = '<option value="">请选择城市</option>'
    $('#coopOrgCityCode').html(cityOption)
  } 
}
function coopOrgDistLabel(id) {
  if(id) {
    $.get(baseUrl + '/api/areas/label/'+ id,function(data) {
      if(data.errorCode == 0){
        var orgDistList = data.data
        var orgDistOption = '<option value="">请选择地区</option>'
        for(var i = 0; i < orgDistList.length; i++){
          orgDistOption += '<option value="'+orgDistList[i].id+'">'+orgDistList[i].text+'</option>'
        }
        $('#coopOrgDistCode').html(orgDistOption)
      }
    })
  }else{
    var orgDistOption = '<option value="">请选择地区</option>'
    $('#coopOrgDistCode').html(orgDistOption)
  }
}


// WEBPACK FOOTER //
// ./src/coopApplication/index.js